import React__default, { useMemo, useState, useEffect } from 'react';
import { kebabToSnakeCase } from '@breville/xps-utils/core/format';
import { getYoutubePreviewImage } from '@breville/xps-utils/core/video';
import { getAttrFromVariant, tryJsonParse } from '../utils.js';
import classNames from 'classnames';
import { VideoPlayer } from '../../VideoPlayer/VideoPlayer.js';

function fetchProductAssets(variant, locale = 'en') {
    var _a;
    const masterProductVariant = {
        type: 'image',
        imageUrl: ((_a = variant.images.find((image) => image.label === 'pdp')) === null || _a === void 0 ? void 0 : _a.url) || '',
        href: '',
        title: (variant === null || variant === void 0 ? void 0 : variant.sku) || '',
        description: (variant === null || variant === void 0 ? void 0 : variant.sku) || '',
        alt: (variant === null || variant === void 0 ? void 0 : variant.sku) || ''
    };
    // Fetch from current variant attributes for images.
    const imagesString = getAttrFromVariant(variant, 'productImages'), images = tryJsonParse((imagesString === null || imagesString === void 0 ? void 0 : imagesString[locale]) || (imagesString === null || imagesString === void 0 ? void 0 : imagesString[locale])), imageNormalized = (images || [])
        .filter((image) => (image === null || image === void 0 ? void 0 : image.imageType) === 'carousel')
        .map((image) => {
        var _a;
        const javaLocale = kebabToSnakeCase(locale), imageText = (_a = image === null || image === void 0 ? void 0 : image.imageText) === null || _a === void 0 ? void 0 : _a[javaLocale];
        return {
            type: 'image',
            imageUrl: (image === null || image === void 0 ? void 0 : image.productImage) || '',
            href: '',
            title: (imageText === null || imageText === void 0 ? void 0 : imageText.imageTitle) || '',
            description: (imageText === null || imageText === void 0 ? void 0 : imageText.imageDesc) || '',
            alt: (imageText === null || imageText === void 0 ? void 0 : imageText.altText) || ''
        };
    });
    // Fetch from current variant attributes for videos.
    const videosString = getAttrFromVariant(variant, 'productVideos'), videos = tryJsonParse((videosString === null || videosString === void 0 ? void 0 : videosString[locale]) || (videosString === null || videosString === void 0 ? void 0 : videosString[locale])), videoNormalized = (videos || [])
        .filter((video) => (video === null || video === void 0 ? void 0 : video.videoType) === 'carousel')
        .map((video) => {
        return {
            type: 'video',
            imageUrl: getYoutubePreviewImage(video === null || video === void 0 ? void 0 : video.videoURL, 'mqdefault'),
            href: (video === null || video === void 0 ? void 0 : video.videoURL) || '',
            title: (video === null || video === void 0 ? void 0 : video.videoTitle) || '',
            description: (video === null || video === void 0 ? void 0 : video.videoAltText) || '',
            alt: (video === null || video === void 0 ? void 0 : video.videoAltText) || ''
        };
    });
    return [masterProductVariant, ...imageNormalized, ...videoNormalized].filter((elem) => !!elem.imageUrl);
}
const VariantViewer = (props) => {
    const { productVariant, options: { aemConfig } } = props, productAssets = useMemo(() => fetchProductAssets(productVariant, aemConfig.locale), [productVariant.key, aemConfig.locale]), [viewIndex, setViewIdx] = useState(0), currentView = productAssets[viewIndex];
    useEffect(() => {
        // If productVariant key changes, reset view index
        if (viewIndex !== 0) {
            setViewIdx(0);
        }
    }, [productVariant.key]);
    return (React__default.createElement("div", { className: 'dt-variant-viewer', "data-testid": 'dt-variant-viewer' },
        React__default.createElement("div", { className: 'viewer-container' },
            React__default.createElement("div", { className: 'viewer-wrapper' },
                (currentView === null || currentView === void 0 ? void 0 : currentView.type) === 'image' && (React__default.createElement("img", { className: 'hero-variant', src: currentView.imageUrl, alt: currentView.alt })),
                (currentView === null || currentView === void 0 ? void 0 : currentView.type) === 'video' && (React__default.createElement("div", { className: 'video-wrapper' },
                    React__default.createElement(VideoPlayer, { videoUrl: currentView.href, playerOptions: {
                            light: currentView.imageUrl
                        } }))))),
        productAssets.length > 1 &&
            React__default.createElement("div", { className: 'variant-assets-wrapper' },
                React__default.createElement("ul", { className: 'assets-list' }, productAssets.map((asset, idx) => {
                    const liClasses = classNames({ active: idx === viewIndex }), buttonClasses = classNames('btn-asset', {
                        video: (asset === null || asset === void 0 ? void 0 : asset.type) === 'video'
                    });
                    return (React__default.createElement("li", { key: idx, className: liClasses },
                        React__default.createElement("button", { type: 'button', className: buttonClasses, onClick: () => setViewIdx(idx) },
                            React__default.createElement("img", { className: 'thumbnail', src: asset.imageUrl, alt: asset.alt, loading: 'lazy' }))));
                })))));
};

export { VariantViewer };
//# sourceMappingURL=index.js.map
